var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.833 5.183a.65.65 0 0 1 .65.65v6.764l7.224-7.223a.65.65 0 0 1 .92.919l-7.224 7.224h6.764a.65.65 0 1 1 0 1.3H5.833a.65.65 0 0 1-.65-.65V5.833a.65.65 0 0 1 .65-.65Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjgzMzMzIDUuMTgzMzNDNi4xOTIzMiA1LjE4MzMzIDYuNDgzMzMgNS40NzQzNSA2LjQ4MzMzIDUuODMzMzNMNi40ODMzMyAxMi41OTc0TDEzLjcwNyA1LjM3MzcxQzEzLjk2MDkgNS4xMTk4NyAxNC4zNzI0IDUuMTE5ODcgMTQuNjI2MyA1LjM3MzcxQzE0Ljg4MDEgNS42Mjc1NSAxNC44ODAxIDYuMDM5MTEgMTQuNjI2MyA2LjI5Mjk1TDcuNDAyNTcgMTMuNTE2N0wxNC4xNjY3IDEzLjUxNjdDMTQuNTI1NyAxMy41MTY3IDE0LjgxNjcgMTMuODA3NyAxNC44MTY3IDE0LjE2NjdDMTQuODE2NyAxNC41MjU2IDE0LjUyNTcgMTQuODE2NyAxNC4xNjY3IDE0LjgxNjdMNS44MzMzMyAxNC44MTY3QzUuNDc0MzUgMTQuODE2NyA1LjE4MzMzIDE0LjUyNTYgNS4xODMzMyAxNC4xNjY3TDUuMTgzMzMgNS44MzMzM0M1LjE4MzMzIDUuNDc0MzUgNS40NzQzNSA1LjE4MzMzIDUuODMzMzMgNS4xODMzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";